module.exports = __webpack_public_path__ + "static/media/UniversityofMaryland.8481e70e.png";